import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

export const header = (isSupplyChainManager = false) => [
  {
    label: 'S.N',
    value: 'S.N',
  },
  {
    label: 'Date',
    value: 'actualCollectionDateMI',
  },
  // {
  //   label: 'Type',
  //   value: 'wasteSource',
  // },
  // {
  //   label: 'Batch id',
  //   value: 'id',
  // },
  {
    label: 'Source',
    value: 'Sourceiscc',
  },
  {
    label: 'feedstock',
    value: 'itemNameisscu',
  },
  {
    label: 'EEC',
    value: 'Cultivation',
  },
  // {
  //   label: isSupplyChainManager ? 'Supply chain' : 'Franchisee',
  //   value: 'franchiseName',
  // },
  {
    label: 'EL',
    value: 'LandUse',
  },
  {
    label: 'ESCA',
    value: 'soilCarbon',
  },
  {
    label: 'M. credits',
    value: 'Methane',
  },
  // {
  //   label: 'Price',
  //   // value: 'price',
  //   value: 'totalAmountI',
  // },
  {
    label: 'ETD',
    value: 'Transportis',
  },
  {
    label: 'GHG',
    value: 'totalV',
  },
  {
    label: 'lhv',
    value: 'EnergyC',
  },
  // {
  //   label: 'Contact',
  //   value: 'customerInfo[mobile]',
  // },
  // {
  //   action: ['view'],
  // },

  {
    label: 'status',
    value: 'isscustatus',
  },

  {
    label: 'Action',
    value: 'viewPdf',
  }
]

const roleColumns = (isSupplyChainManager = false) => {
  return columnGenerators(header(isSupplyChainManager))
}
export { roleColumns }
